export function getView(is_enabled) {
  return is_enabled ? 'New' : 'Old'
}
